$(".center_slide").slick({
  centerMode: true,
  slidesToShow: 1,
  autoplay: true,
  pauseOnFocus: false,
  autoplaySpeed: 2500,
});
$(".collection_slide").slick({
  swipeToSlide: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: true,
  pauseOnFocus: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        // centerMode: true,
        centerPadding: "40px",
        arrows: true,
        slidesToShow: 2,
      },
    },
  ],
});

$(".featured_slide").slick({
  infinite: true,
  swipeToSlide: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: true,
  pauseOnFocus: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        centerPadding: "40px",
        arrows: true,
        slidesToShow: 2,
      },
    },
  ],
});

//Site Loading
$(window).on("load", function () {
  $(".lp_loading").addClass("animation_top");
  $(function () {
    var img = $("img");
    img.css({ "pointer-events": "none" });
  });
  // document.oncontextmenu = function(){ return false; };
  // document.body.oncontextmenu = "return false;"
  setTimeout(removetab, 2000);
});

function opentab(evt, Name) {
  var i, tabcontent, tablinks;

  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
    // tabcontent[i].style.opacity = "0";
    tabcontent[i].style.height = "0";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  evt.currentTarget.className += " active";
  document.getElementById(Name).style.display = "block";
  // document.getElementById(Name).style.opacity = "1";
  document.getElementById(Name).style.height = "auto";
}

function removetab() {
  const defaultTab = document.getElementById("defaultOpen");
  if (defaultTab) {
    defaultTab.click();
  } else {
    console.warn("defaultOpen 要素が存在しません。");
  }
}
       